
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import config from "@/config/config";
import gateway from "@/lib/request/gateway";
import PostPolicy from "@/lib/model/gateway/post-policy";
import _ from "lodash-es";
import Auth from "@/lib/common/auth";
import UploadedFile from "@/lib/model/gateway/uploaded-file";

@Component({})
export default class UploadImg extends Vue {
  @Prop({ default: "examLogoUrl", type: String }) private imgType!: string;
  @Prop({ default: "", type: String }) private img!: string;
  name = "paper-list";
  loading = false;
  params = {};
  headers = {};
  imageUrl = "";
  postPolicy: PostPolicy = new PostPolicy();
  uploadFile: UploadedFile = new UploadedFile();

  get uploadUrl() {
    return _.trim(config.accountUrl) + "/api/common/uploadOss";
  }
  get token() {
    return Auth.token;
  }

  @Watch("img")
  onImgChange(val: string) {
    this.imageUrl = val;
  }

  afterUpload(e: any) {
    this.loading = false;
    if (e.code === 0) {
      this.imageUrl = e.data.url;
    }
  }
  uploadImg(data: { filename: string; file: File }) {
    const { file } = data;
    this.loading = true;
    const isJPG =
      file.type === "image/jpeg" ||
      file.type === "image/jpg" ||
      file.type === "image/png";
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isJPG) {
      this.$message.error("上传图片只能是 JPG/JPEG/PNG 格式!");
      this.loading = false;
    }
    if (!isLt2M) {
      this.$message.error("上传图片过大!");
      this.loading = false;
    }
    // 上传图片到oss
    gateway.anonymousGetPostPolicy(file.name).then((postRes: any) => {
      if (postRes) {
        const tempUrl = postRes.cdn + "/" + encodeURIComponent(postRes.dir);
        gateway
          .upload(postRes, file)
          .then((res: any) => {
            console.log("upload res : ", res);
          })
          .finally(() => {
            this.imageUrl = tempUrl;
            this.$emit("change", this.imageUrl);
          });
      }
    });
  }

  uploadSuccess(e: any) {
    this.loading = false;
    if (e.code === 0) {
      this.imageUrl = e.data.url;
      this.$message.success("上传成功");
    }
  }
  error() {
    console.log("error");
  }
}
